// HeroSection.js
import React from 'react';
import '../styles/components/hero.css'; // Import custom CSS for animations
import logo from '../images/logo.png';
import heroBackgroundImage from '../images/bglogo5.png'; // Add your background image
import { ChevronRight } from 'react-feather';

const HeroSection = () => {
  // Define background style with your image
  const heroStyle = {
    backgroundImage: `
      linear-gradient(130deg, rgba(255, 255, 255, 0.12) 40%, rgba(248, 249, 250, 0.63) 65%),
      url(${heroBackgroundImage})
    `,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'auto'
  };

  return (
    <>
      <section className="hero-section" style={heroStyle}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-8 hero-content">
              <div className="fadeInLeft">
                <span className="badge badge-primary">Technology Leaders</span>
                <h1>Leading the Wave of Tech Revolution</h1>
                <p className="hero-subtitle">
                  Empowering enterprises with Quantum, Blockchain, AI - Integration and cutting-edge
                  Digital solutions for the challenges of tomorrow.
                </p>
                <p className="hero-subtitle">
                  We are towards Transformative Intelligence where Quantum, AI & ML lead to more
                  powerful, efficient, and intelligent systems.
                </p>
                <div className="hero-btns">
                  <a href="/explore_solutions" className="btn btn-primary ">
                    Explore Solutions
                    <ChevronRight size={16} />
                  </a>
                  <a href="/request_form" className="btn btn-success">
                    Request Form
                    <ChevronRight size={16} />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-4 hero-image-container">
              <div className="hero-image">
                <img src={logo} alt="Olewin Tech Solutions Logo" className="img-fluid floating" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HeroSection;